module.exports = __webpack_public_path__ + "static/img/daId@2x.58b086a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/gallery/daId@2x.png
// module id = wYG3
// module chunks = 1